import "./Tooltip.css";

import Tooltip from "rc-tooltip";
import { ReactNode } from "react";

import { CloseDarkIcon, TooltipInfoLightIcon } from "../../../assets";
import { useTooltip } from "./useTooltip";

type TooltipPlacement = "bottomLeft" | "bottomRight";

export interface TooltipProps {
  placement?: TooltipPlacement;
  tooltipHeader: string;
  tooltipText: string;
  allowDangerousHtml?: boolean;
  icon?: ReactNode;
  linkText?: string;
  fill?: boolean;
  hasError?: boolean;
}

const tooltipContainer = (
  tooltipHeader: string,
  tooltipText: string,
  handleVisible: () => void,
  allowDangerousHtml?: boolean
): JSX.Element => {
  return (
    <div className="TooltipContainer">
      <div className="TooltipContainerIcon">
        <CloseDarkIcon onClick={handleVisible} />
      </div>
      <h3>{tooltipHeader}</h3>
      {allowDangerousHtml ? (
        // eslint-disable-next-line react/no-danger
        <div className="body1" dangerouslySetInnerHTML={{ __html: tooltipText }} />
      ) : (
        <div className="body1">{tooltipText}</div>
      )}
    </div>
  );
};

export const KanaTooltip = ({
  tooltipHeader,
  tooltipText,
  placement = "bottomLeft",
  allowDangerousHtml = false,
  icon = <TooltipInfoLightIcon />,
  linkText,
  fill = true,
  hasError = false,
}: TooltipProps): JSX.Element => {
  const { isVisible, handleVisibleChange } = useTooltip();

  return (
    <Tooltip
      placement={placement}
      visible={isVisible}
      onVisibleChange={(visible: boolean) => handleVisibleChange(visible)}
      overlayClassName="KanaTooltip"
      overlay={tooltipContainer(
        tooltipHeader,
        tooltipText,
        () => {
          handleVisibleChange(false);
        },
        allowDangerousHtml
      )}
    >
      <div
        className={`TooltipChild ${fill ? "TooltipFill" : ""} ${linkText ? "TooltipChildLink" : ""} ${
          hasError ? "TooltipChildError" : ""
        }`}
      >
        {linkText && fill ? <h3>{linkText}</h3> : <p>{linkText}</p>}
        {icon}
      </div>
    </Tooltip>
  );
};
